import React from 'react'

import { Box, Display, DisplayPosition, JustifyContent } from '@gousto-internal/citrus-react'

import type { StandardRecipeItem } from '@library/api-menu-experience'

import { TileImage as RecipeTileImage } from '../../RecipeTileImage/TileImage'
import { RecipeDietaryTagOverlay, RecipeTagLabels } from '../../../RecipeTileTags'
import { ImageContainer } from '../RecipeTile.styles'
import { SoldOutOverlay } from '../SoldOutOverlay'
import { getRecipeTileGeneralTags } from '../RecipeTile.utils'

type RecipeTileImageSectionProps = {
  recipe: StandardRecipeItem
  isOutOfStock: boolean
  lazy: boolean
  insideOverflow: boolean
  flexPortionBadge?: React.ReactNode
  isFlexPortionEditorOpen?: boolean
}

export const RecipeTileImageSection = ({
  recipe,
  isOutOfStock,
  lazy,
  insideOverflow,
  flexPortionBadge,
  isFlexPortionEditorOpen = false,
}: RecipeTileImageSectionProps) => {
  const generalTags = getRecipeTileGeneralTags(recipe)
  const dietaryTags = recipe.tagGroups.dietary ?? []

  return (
    <ImageContainer>
      <SoldOutOverlay isOutOfStock={isOutOfStock} />
      <RecipeTileImage
        lazy={lazy}
        recipe={{
          images: [
            {
              ...recipe.image,
              type: recipe.image.type ?? 'image',
            },
          ],
          name: recipe.title,
        }}
        insideOverflow={insideOverflow}
        testId="recipe-tile-image"
      />
      {!flexPortionBadge && (
        <>
          <RecipeTagLabels
            tags={generalTags}
            isOutOfStock={isOutOfStock}
            reserveEndSpace
            stacked
            dataTestId="recipe-tile-general-labels"
            style={{ left: 0 }}
          />
          <RecipeDietaryTagOverlay tags={dietaryTags} variant="stacked" />
        </>
      )}
      {flexPortionBadge && (
        <Box
          display={Display.Flex}
          justifyContent={JustifyContent.FlexEnd}
          position={DisplayPosition.Absolute}
          left="1rem"
          right="1rem"
          bottom="1rem"
          onMouseDown={(event: React.MouseEvent) => {
            if (isFlexPortionEditorOpen) {
              event.stopPropagation()
            }
          }}
          onClick={(event: React.MouseEvent) => event.stopPropagation()}
          onKeyDown={(event: React.KeyboardEvent) => event.stopPropagation()}
          style={{ zIndex: 30 }}
        >
          {flexPortionBadge}
        </Box>
      )}
    </ImageContainer>
  )
}
